import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';

import { useState, useRef, useEffect } from 'react';
import { useCallback } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import roundThumbUp from '@iconify/icons-ic/round-thumb-up';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import moreHorizontalFill from '@iconify/icons-eva/more-horizontal-fill';
// material
import { MobileDateRangePicker, LoadingButton } from '@material-ui/lab';
import { styled } from '@material-ui/core/styles';
import {
    Box,
    Stack,
    Drawer,
    Button,
    Avatar,
    Tooltip,
    Divider,
    MenuItem,
    TextField,
    Typography,
    OutlinedInput,
    Grid,
    Card,
    Tabs,
    Tab,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Container,
    InputAdornment
} from '@material-ui/core';
//

import { MIconButton, MHidden } from '../../../components/@material-extend';
import apiContact from '../../../api/contact';
import apiUser from '../../../api/user';
import { useSnackbar } from 'notistack5';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------
import useAuth from '../../../hooks/useAuth'
import { objectID } from '../../../utils/objectID';
import { useSelector } from 'react-redux';

import { capitalCase } from 'change-case';
import Scrollbar from '../../../components/Scrollbar';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const PRIORITIZES = ['low', 'medium', 'hight'];

FStaff.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    card: PropTypes.object,
    onDeleteTask: PropTypes.func
};

const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.body2,
    width: 140,
    fontSize: 13,
    flexShrink: 0,
    color: theme.palette.text.secondary
}));

// ----------------------------------------------------------------------

export default function FStaff({ isOpen, onClose, formik, listUser, isReadOnly, selectedTicket }) {
    const fileInputRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { user } = useAuth();
    const handleAttach = () => {
        fileInputRef.current.click();
    };
    const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;
    const handleChange = (e) => {
        setFieldValue(e.target.name, e.target.value)
    }
    return (
        <>
            <Box

                sx={{
                    '& > :not(style)': { m: 1, mb: 1 },
                }}
            >
                <Stack direction={"column"} justifyContent={'stretch'} spacing={2}>
                    {!selectedTicket ? <TextField
                        id="full-width-text-field"
                        label="Người chỉ định"
                        size="small"
                        placeholder="Placeholder"
                        //  helperText="Full width!"
                        name="designator_id"
                        select
                        fullWidth
                        onChange={handleChange}
                        error={Boolean(touched.designator_id && errors.designator_id)}
                        helperText={touched.designator_id && errors.designator_id}
                        value={user.id}
                        SelectProps={{
                            MenuProps: {
                                sx: { maxHeight: 200 }
                            }
                        }}
                        disabled={isReadOnly}
                    >
                        <MenuItem value={user.id}>Tôi</MenuItem>
                        {/* {listUser && listUser.map((item, index) => {
                            if (objectID(item._id) != user.id) {
                                return (
                                    <MenuItem key={index} value={objectID(item._id)}>
                                        <Stack direction={"row"} alignItems={"center"} >
                                            <Avatar key={user.id} alt={user.name} src={user.avatar} sx={{ m: 0.5, width: 36, height: 36 }} />
                                            <Typography variant='body2'> {item.full_name}</Typography>
                                        </Stack>
                                    </MenuItem>
                                )

                            }
                        })} */}


                    </TextField> : <TextField size="small" disabled={isReadOnly} id="full-width-text-field" label="Người tiếp nhận" placeholder="Placeholder" value={selectedTicket.designator_name}></TextField>
                    }
                    {!selectedTicket ?
                        <TextField
                            size="small"
                            id="full-width-text-field"
                            label="Người tiếp nhận"
                            placeholder="Placeholder"
                            //  helperText="Full width!"
                            select
                            name="reciever_id"
                            onChange={handleChange}
                            fullWidth
                            error={Boolean(touched.reciever_id && errors.reciever_id)}
                            helperText={touched.reciever_id && errors.reciever_id}
                            defaultValue={values?.reciever_id}
                            value={values?.reciever_id}
                            SelectProps={{
                                MenuProps: {
                                    sx: { maxHeight: 200 }
                                }
                            }}
                            disabled={isReadOnly}
                        >
                            <MenuItem value={user?.id}>
                                <Stack direction={"row"} alignItems={"center"} >
                                    <Avatar key={user?.id} alt={user?.name} src={user?.avatar} sx={{ m: 0.5, width: 36, height: 36 }} />
                                    <Typography variant='body2'>  Tôi</Typography>
                                </Stack>
                            </MenuItem>
                            {listUser && listUser.map((item, index) => {
                                if (objectID(item._id) != user?.id) {
                                    return (
                                        <MenuItem key={index} value={objectID(item._id)}>
                                            <Stack direction={"row"} alignItems={"center"} >
                                                <Avatar key={user?.id} alt={user?.name} src={user?.avatar} sx={{ m: 0.5, width: 36, height: 36 }} />
                                                <Typography variant='body2'> {objectID(item._id) != user.id ? item?.full_name : "Tôi"}</Typography>
                                            </Stack>
                                        </MenuItem>
                                    )
                                }
                            })}

                        </TextField> : <TextField size="small" disabled={isReadOnly} id="full-width-text-field" label="Người tiếp nhận" placeholder="Placeholder" value={selectedTicket.reciever_name}></TextField>

                    }

                    <TextField
                        id="outlined-basic"
                        fullWidth
                        label="Nhắc hẹn "
                        variant="outlined"
                        name='remind_in'
                        {...getFieldProps('remind_in')}
                        type='number'
                        error={Boolean(touched.remind_in && errors.remind_in)}
                        helperText={touched.remind_in && errors.remind_in}
                        defaultValue={values.remind_in}
                        InputProps={{
                            endAdornment: <InputAdornment position='end'>Phút</InputAdornment>
                        }}
                    />
                </Stack>

            </Box>
        </>
    );
}
